import React from 'react';
import { Link } from 'react-router-dom';
import NotFoundImage from '../../../src/images/notfound.svg'
import Navbar from '../Navbar/Navbar';

const NotFound = () => {
    return (
        <div>
            <Navbar></Navbar>
            <div className='container text-center text-danger p-5'>
            
            <img src={NotFoundImage} alt='...' style={{height: '200px'}}/>
            <h1 className='pt-5'>Oops!</h1>
            <h4>Page Not Found</h4>
            <Link to='/' className='btn btn-success'>Go Back Home</Link>
        </div>
        </div>
    );
};

export default NotFound;